<template>
  <b-container>
    <b-row class="mt-3">
      <b-col cols="2"></b-col>
      <b-col cols="8" class="text-center"><b-img src="http://api.checkpoint.recco.com.br/image_recco/recco.png" fluid style="width:100%; max-width:300px;"/></b-col>
      <b-col cols="2"></b-col>
    </b-row>
    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="10">
        <div class="card text-white mt-4" style="background:#D30556;">
          <div class="card-header">Redefinir Senha</div>
          <div class="card-body">
            <b-form @submit="onSubmit" autocomplete="off">
              <b-form-group>
                <b-form-input type="password" v-model="passwordNew" required placeholder="Nova Senha"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input type="password" v-model="passwordCheck" required placeholder="Confirmar Senha"></b-form-input>
              </b-form-group>
              <b-button type="submit" style="background:#870337; border:none;">Salvar</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col cols="1"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'

export default {
  data () {
    return { passwordCheck: '', passwordNew: '' }
  },
  created: function() {
    // Verifica se existe o item token no localStorage.
    if (localStorage.getItem('token')) this.$router.push('home');
  },
  methods: {
    onSubmit (event) {
      // Não permite o envio do formulário.
      event.preventDefault();

      if(this.passwordCheck != this.passwordNew) {
        swal({
          type: 'error',
          title: 'Erro...',
          text: 'Sua senha não confere, com a confirmação!'
        })
      } else {
        // Requisição ao webservice.
        http.post('/user/password', {passwordCheck: this.passwordCheck, password: this.passwordNew, hash: this.$route.params.hash})
          .then(response => {
            swal({
              icon: 'success',
              title: 'Ok!',
              text: response.data.mensagem
            })
            // Redirecionado para a login.
            this.$router.push('/')
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      }
    }
  }
}
</script>

<style scoped>
input, button { font-family:'Roboto', sans-serif; }
</style>



// WEBPACK FOOTER //
// src/components/Password.vue